import {
    NotificationPage,
    NotificationSettings,
    NotificationStatus,
} from "../../types/NotificationTypes";
import { safeGET, safePUT } from "./SafeClient";

/**
 * The current user's notifications, newest first: `limit` of them, older than
 * `before` when given (the `next` of the previous page).
 */
export function listNotifications(
    limit: number,
    before?: number | null,
    abort?: any
): Promise<NotificationPage> {
    const params = new URLSearchParams({ limit: String(limit) });
    if (before != null) params.set("before", String(before));
    return safeGET(`/api/notifications?${params.toString()}`, abort);
}

/**
 * What the nav polls: the unread count, the newest id, and what arrived
 * after the id given (none without one; see NotificationStatus).
 */
export function getNotificationStatus(after?: number, abort?: any): Promise<NotificationStatus> {
    const params = new URLSearchParams();
    if (after != null) params.set("after", String(after));
    return safeGET(`/api/notifications/status?${params.toString()}`, abort);
}

/** The user saw this notification. */
export function markNotificationRead(id: number, abort?: any): Promise<void> {
    return safePUT(`/api/notifications/${id}/read`, undefined, abort);
}

/** The user asked for a clean slate: none is new any more. */
export function markNotificationsRead(abort?: any): Promise<void> {
    return safePUT("/api/notifications/read", undefined, abort);
}

export function getNotificationSettings(abort?: any): Promise<NotificationSettings> {
    return safeGET("/api/notifications/settings", abort);
}

export function updateNotificationSettings(
    settings: NotificationSettings,
    abort?: any
): Promise<NotificationSettings> {
    return safePUT("/api/notifications/settings", settings, abort);
}
